import React from "react";

const HttpContext = React.createContext({});

export const HttpProvider = HttpContext.Provider;
export const HttpConsumer = HttpContext.Consumer;
export default HttpContext;
